module.exports = __webpack_public_path__ + "static/media/sticker_01.10f9ecff.svg";